// Meridian Dental Studio — central site content. Edit here to update the whole site.

export const demoNotice =
  "Demo Site Notice: This is a demonstration website for portfolio purposes only. No actual dental appointments are scheduled, and no patient data is collected or processed.";

export const agencyUrl = "https://anantadigitalworks.com/";


export const business = {
  name: "Meridian Dental Studio",
  shortName: "Meridian",
  tagline: "Elevated dentistry in the heart of Hell's Kitchen.",
  neighborhood: "Hell's Kitchen, Manhattan",
  bookingUrl: "https://calendar.app.google/D2QK837tSQEy3UY36",  phoneDisplay: "(212) 555-0142",
  phoneHref: "tel:+12125550142",
  smsHref: "sms:+12125550142",
  email: "hello@meridiandentalstudio.com",
  emailHref: "mailto:hello@meridiandentalstudio.com",
  address1: "555 West 42nd Street, Suite 200",
  address2: "New York, NY 10036",
  crossStreets: "Between 10th & 11th Avenue",
  mapEmbed:
    "https://www.google.com/maps?q=555+West+42nd+Street+New+York+NY+10036&output=embed",
  directionsHref:
    "https://www.google.com/maps/dir/?api=1&destination=555+West+42nd+Street+New+York+NY+10036",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 3:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  transit: [
    "A · C · E at 42 St – Port Authority (3 min walk)",
    "1 · 2 · 3 · 7 · N · Q · R · W at Times Sq – 42 St (7 min walk)",
    "M11 · M42 bus at 11th Ave & 42nd St (steps away)",
  ],
  serviceAreas: [
    "Hell's Kitchen",
    "Clinton",
    "Midtown West",
    "Chelsea",
    "Times Square",
    "Hudson Yards",
    "Theater District",
    "Manhattan",
  ],
  social: {
    // Leave empty string to hide the link entirely (no fake links published).
    instagram: "https://www.instagram.com/meridiandentalstudio/",
    facebook: "https://www.facebook.com/meridiandentalstudio",
  },
};

export const stats = [
  { value: "18k+", label: "Smiles cared for" },
  { value: "4.9★", label: "Average patient rating" },
  { value: "20+", label: "Years serving Manhattan" },
  { value: "Same-day", label: "Emergency visits" },
];

export const trustBadges = [
  "American Dental Association",
  "Academy of Cosmetic Dentistry",
  "Invisalign Diamond Provider",
  "NYU College of Dentistry",
  "OSHA Certified Sterilization",
  "CareCredit Partner",
];

export const services = [
  {
    slug: "preventative-care",
    index: "01",
    name: "Preventative Care",
    short: "Cleanings, exams, screenings & fluoride to keep every smile healthy for life.",
    seoTitle:
      "Preventative Dentist Hell's Kitchen NYC | Cleanings & Exams | Meridian Dental",
    seoDescription:
      "Gentle dental cleanings, comprehensive exams, oral cancer screenings and fluoride treatments in Hell's Kitchen, Manhattan. Book your preventative visit at Meridian Dental Studio.",
    hero: "https://images.pexels.com/photos/15073697/pexels-photo-15073697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Prevention is the quietest form of luxury. Our Hell's Kitchen hygienists pair unhurried, meticulous cleanings with digital diagnostics so small issues never become big ones — keeping busy New Yorkers out of the chair and on with their day.",
    treatments: [
      { name: "Professional Cleanings", duration: "45–60 min", note: "No downtime. Twice yearly recommended." },
      { name: "Comprehensive Exams", duration: "30–45 min", note: "Digital X-rays included, radiation-minimized." },
      { name: "Oral Cancer Screenings", duration: "10 min", note: "Fast, painless VELscope screening." },
      { name: "Fluoride & Sealants", duration: "15 min", note: "Extra protection for adults and kids alike." },
    ],
    technology: ["Low-radiation digital X-rays", "Intraoral scanners", "VELscope oral cancer imaging", "Airflow polishing"],
    comfort: ["Noise-canceling headphones", "Weighted blankets", "Numbing gels before every probe", "Flexible early & Saturday hours"],
    related: ["cosmetic-dentistry", "restorative-care"],
    keywords: "dental cleanings Hell's Kitchen New York, family dental practice Hell's Kitchen NYC, best dentists Hell's Kitchen NYC",
  },
  {
    slug: "cosmetic-dentistry",
    index: "02",
    name: "Cosmetic Dentistry",
    short: "Whitening, porcelain veneers, bonding & full smile makeovers designed around your face.",
    seoTitle:
      "Best Cosmetic Dentist Hell's Kitchen, Manhattan NYC | Veneers & Whitening | Meridian",
    seoDescription:
      "Porcelain veneers, teeth whitening, bonding and smile makeovers by an award-recognized cosmetic dentist in Hell's Kitchen, Manhattan. See real before & afters and book today.",
    hero: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    intro:
      "A confident smile is your most-worn accessory. Our cosmetic work is designed digitally and previewed before we ever touch a tooth — so the smile you approve on screen is the smile you walk out with, tailored to your face and the New York light.",
    treatments: [
      { name: "Teeth Whitening", duration: "60 min in-office", note: "Up to 8 shades brighter, same day." },
      { name: "Porcelain Veneers", duration: "2 visits", note: "Digitally designed, hand-finished by ceramists." },
      { name: "Cosmetic Bonding", duration: "30–60 min", note: "Chips & gaps corrected in a single visit." },
      { name: "Smile Makeovers", duration: "Custom plan", note: "A fully mapped, phased transformation." },
    ],
    technology: ["Digital Smile Design", "3D intraoral scanning", "Shade-matching photography", "Same-day trial smiles"],
    comfort: ["Preview your smile before treatment", "Sedation options available", "Streaming & headphones", "Transparent, phased pricing"],
    related: ["orthodontics", "restorative-care"],
    keywords: "best cosmetic dentist Hell's Kitchen Manhattan NYC, teeth whitening near me NYC, porcelain veneers near me Hell's Kitchen New York",
  },
  {
    slug: "restorative-care",
    index: "03",
    name: "Restorative Care",
    short: "Implants, crowns & bridges, root canals & fillings that rebuild function and comfort.",
    seoTitle:
      "Dental Implants & Root Canals Hell's Kitchen NYC | Restorative Dentist | Meridian",
    seoDescription:
      "Dental implants, crowns & bridges, gentle root canals and tooth-colored fillings in Hell's Kitchen, Manhattan. Rebuild your smile comfortably at Meridian Dental Studio.",
    hero: "https://images.unsplash.com/photo-1593022356769-11f762e25ed9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    intro:
      "When a tooth needs rebuilding, precision matters most. We combine 3D imaging with modern materials to restore strength, bite and appearance — with root canals so gentle our patients routinely say they didn't feel a thing.",
    treatments: [
      { name: "Dental Implants", duration: "Staged, 3–6 mo", note: "Guided placement with 3D planning." },
      { name: "Crowns & Bridges", duration: "1–2 visits", note: "Natural-looking, long-lasting ceramics." },
      { name: "Root Canals", duration: "60–90 min", note: "Rotary endodontics, virtually painless." },
      { name: "Tooth-Colored Fillings", duration: "30–45 min", note: "Mercury-free, matched to your enamel." },
    ],
    technology: ["3D cone-beam CT imaging", "Guided implant surgery", "Rotary endodontics", "Laser dentistry"],
    comfort: ["IV & oral sedation", "Same-day emergency slots", "Financing on larger cases", "Warm, unhurried appointments"],
    related: ["preventative-care", "cosmetic-dentistry"],
    keywords: "dental implants near me Hell's Kitchen NY, root canal near me Hell's Kitchen NYC, emergency dentist near me Hell's Kitchen New York",
  },
  {
    slug: "orthodontics",
    index: "04",
    name: "Orthodontics",
    short: "Invisalign, clear aligners & retainers that straighten discreetly on your schedule.",
    seoTitle:
      "Invisalign Hell's Kitchen NYC | Clear Aligners & Orthodontics | Meridian Dental",
    seoDescription:
      "Invisalign, clear aligners and retainers from a Diamond-level provider in Hell's Kitchen, Manhattan. Straighten your smile discreetly. Free aligner consult — book today.",
    hero: "https://images.unsplash.com/photo-1667133295315-820bb6481730?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    intro:
      "Straightening should fit your life, not interrupt it. As a Diamond-level Invisalign practice, we map your entire journey in 3D on day one — so you can see your future smile and get to it with fewer, faster visits.",
    treatments: [
      { name: "Invisalign", duration: "6–18 months", note: "Removable, nearly invisible aligners." },
      { name: "Clear Aligners", duration: "4–12 months", note: "Great for minor corrections & relapse." },
      { name: "Retainers", duration: "Same week", note: "Custom-fit to protect your results for life." },
      { name: "Teen & Adult Programs", duration: "Custom plan", note: "Discreet options for every stage." },
    ],
    technology: ["3D aligner outcome simulation", "iTero scanning (no goopy molds)", "Remote check-in monitoring", "Precision attachment planning"],
    comfort: ["See your result before you start", "Fewer in-office visits", "Whitening bundled with treatment", "Flexible monthly financing"],
    related: ["cosmetic-dentistry", "preventative-care"],
    keywords: "invisalign near me Hell's Kitchen NY, invisalign near me Hell's Kitchen NYC, clear aligners Manhattan",
  },
];

export const team = [
  {
    name: "Dr. Elena Marchetti",
    role: "Founder · Cosmetic & Restorative Dentist",
    credentials: "DDS, NYU College of Dentistry · AACD Accredited",
    bio: "Elena founded Meridian to bring museum-level craft to everyday dentistry. She lectures on Digital Smile Design and has rebuilt smiles for New Yorkers from Broadway stages to boardrooms.",
    photo: "https://images.pexels.com/photos/31043312/pexels-photo-31043312.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    specialties: ["Porcelain Veneers", "Smile Design", "Full-Mouth Restoration"],
  },
  {
    name: "Dr. Julian Reyes",
    role: "Orthodontist · Invisalign Diamond Provider",
    credentials: "DMD, MS Orthodontics · Columbia University",
    bio: "Julian has guided thousands of aligner journeys. He is known for a warm chairside manner and treatment plans that respect the schedules of busy Manhattan professionals.",
    photo: "https://images.unsplash.com/photo-1729162128021-f37dca3ff30d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    specialties: ["Invisalign", "Clear Aligners", "Teen Orthodontics"],
  },
  {
    name: "Dr. Marcus Whitfield",
    role: "Implant & Restorative Surgeon",
    credentials: "DDS · Fellow, International Congress of Oral Implantologists",
    bio: "Marcus brings calm precision to complex restorative and implant cases, pairing 3D-guided surgery with a gentle, reassuring approach that puts anxious patients at ease.",
    photo: "https://images.unsplash.com/photo-1674775372058-c4c8813c6611?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    specialties: ["Dental Implants", "Root Canals", "Sedation Dentistry"],
  },
  {
    name: "Sofia Nguyen, RDH",
    role: "Lead Hygienist & Patient Coordinator",
    credentials: "Registered Dental Hygienist · Sterilization Lead",
    bio: "Sofia sets the tone the moment you arrive — coordinating comfort, insurance and follow-up while running our meticulous, hospital-grade hygiene program.",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    specialties: ["Preventative Care", "Patient Comfort", "Infection Control"],
  },
];

// Before/After gallery. `before` and `after` are image URLs for the draggable slider.
export const gallery = [
  {
    id: "veneers-1",
    title: "Porcelain Veneers",
    category: "Cosmetic",
    service: "cosmetic-dentistry",
    caption: "Eight upper veneers · single smile makeover",
    before: "https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    after: "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "invisalign-1",
    title: "Invisalign Alignment",
    category: "Orthodontics",
    service: "orthodontics",
    caption: "11 months of clear aligners",
    before: "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    after: "https://images.unsplash.com/photo-1548382131-e0ebb1f0cdea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "whitening-1",
    title: "In-Office Whitening",
    category: "Cosmetic",
    service: "cosmetic-dentistry",
    caption: "One session · seven shades brighter",
    before: "https://images.unsplash.com/photo-1548382131-e0ebb1f0cdea?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    after: "https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "implant-1",
    title: "Implant Restoration",
    category: "Restorative",
    service: "restorative-care",
    caption: "Single implant & ceramic crown",
    before: "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    after: "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "makeover-1",
    title: "Full Smile Makeover",
    category: "Cosmetic",
    service: "cosmetic-dentistry",
    caption: "Whitening, bonding & alignment combined",
    before: "https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    after: "https://images.unsplash.com/photo-1548382131-e0ebb1f0cdea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "hygiene-1",
    title: "Deep Cleaning & Polish",
    category: "Preventative",
    service: "preventative-care",
    caption: "Stain removal & Airflow polishing",
    before: "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    after: "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const galleryFilters = ["All", "Cosmetic", "Restorative", "Orthodontics", "Preventative"];

export const reviews = [
  {
    name: "Amara O.",
    area: "Hell's Kitchen",
    text: "Genuinely the calmest dental visit of my life. The headphones, the blanket, the honesty about pricing — Meridian gets it.",
    rating: 5,
  },
  {
    name: "David L.",
    area: "Chelsea",
    text: "My veneers look completely natural. Dr. Marchetti previewed everything digitally so there were zero surprises.",
    rating: 5,
  },
  {
    name: "Priya S.",
    area: "Midtown West",
    text: "Cracked a tooth on a Friday and they saw me same day. Painless root canal — I didn't feel a thing.",
    rating: 5,
  },
  {
    name: "Marcus T.",
    area: "Hudson Yards",
    text: "Finished Invisalign in under a year with barely any office visits. Perfect for my schedule.",
    rating: 5,
  },
];

export const faqs = [
  {
    q: "Do you take dental insurance?",
    a: "Yes. We are in-network with most major PPO plans and file claims on your behalf. Not sure about your plan? Call or text us and we'll verify your benefits before your visit.",
  },
  {
    q: "I have a dental emergency — can I be seen today?",
    a: "Absolutely. We reserve same-day emergency slots every weekday for broken teeth, severe pain, swelling and lost restorations. Call (212) 555-0142 and tell us it's urgent.",
  },
  {
    q: "How do payment plans and financing work?",
    a: "We partner with CareCredit and offer in-house membership plans for patients without insurance. Larger treatments can be split into manageable monthly payments — we'll map costs transparently before you commit.",
  },
  {
    q: "I'm anxious about the dentist. What comfort options do you offer?",
    a: "You're in good company. We offer noise-canceling headphones, weighted blankets, streaming, topical numbing, and oral or IV sedation for longer or more involved procedures.",
  },
  {
    q: "How strict is your sterilization protocol?",
    a: "Hospital-grade. We follow OSHA and CDC guidelines with autoclave sterilization, single-use disposables where possible, HEPA air filtration and surface disinfection between every patient.",
  },
  {
    q: "Where exactly are you located and how do I get there?",
    a: "We're at 555 West 42nd Street in Hell's Kitchen, between 10th & 11th Avenue — a 3-minute walk from the A/C/E at 42 St–Port Authority and close to the 1/2/3/7/N/Q/R/W at Times Sq–42 St.",
  },
];

export const insurance = {
  ppo: ["Delta Dental", "Cigna", "Aetna", "MetLife", "Guardian", "United Healthcare", "Empire BCBS", "Humana"],
  financing: [
    { name: "CareCredit", desc: "0% and low-interest healthcare financing with instant approval." },
    { name: "Meridian Membership", desc: "No-insurance plans covering cleanings, exams, X-rays and member-only discounts." },
    { name: "Monthly Payment Plans", desc: "Split larger treatments like implants or veneers into predictable monthly payments." },
  ],
};
